import React, { useContext } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { AuthContextWeb } from "../context/AuthContextWeb";
import {
  LayoutDashboard,
  List,
  PlusSquare,
  Mail,
  UserCircle,
  LogOut,
} from "lucide-react";

const ownerTabs = [
  { to: "/owner/dashboard", label: "Dashboard", Icon: LayoutDashboard },
  { to: "/owner/listings", label: "My Listings", Icon: List },
  { to: "/owner/add-property", label: "Add Property", Icon: PlusSquare },
  { to: "/owner/inbox", label: "Inbox", Icon: Mail },
  { to: "/owner/account", label: "Account", Icon: UserCircle },
];

export default function OwnerAppLayout() {
  const { user, logout } = useContext(AuthContextWeb);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/app/login");
  };

  return (
    <div className="owner-shell">
      <aside className="owner-sidebar">
        <div className="owner-sidebar-brand">
          <Link to="/" aria-label="Rental Highway Home">
            <img
              src="/assets/logo/LogoH.png"
              alt="Rental Highway"
              className="owner-sidebar-logo"
            />
          </Link>
        </div>

        <nav className="owner-nav" aria-label="Owner navigation">
          {ownerTabs.map(({ to, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                isActive ? "owner-nav-item active" : "owner-nav-item"
              }
            >
              <Icon size={18} strokeWidth={1.75} className="owner-nav-icon" />
              <span className="owner-nav-label">{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="owner-sidebar-footer">
          <div className="owner-user-pill">
            <div className="owner-user-avatar">
              {(user?.name || "O").charAt(0).toUpperCase()}
            </div>
            <div className="owner-user-info">
              <p className="owner-user-name">{user?.name || "Owner"}</p>
              <p className="owner-user-role">Property Owner</p>
            </div>
          </div>
          <button
            type="button"
            className="owner-logout-btn"
            onClick={handleLogout}
          >
            <LogOut size={15} strokeWidth={1.75} style={{ flexShrink: 0 }} />
            Sign out
          </button>
        </div>
      </aside>

      <div className="owner-content">
        {/* Mobile top bar */}
        <header className="owner-topbar">
          <Link to="/" aria-label="Rental Highway Home">
            <img
              src="/assets/logo/LogoH.png"
              alt="Rental Highway"
              className="owner-topbar-logo"
            />
          </Link>
          <nav className="owner-topbar-nav">
            {ownerTabs.map(({ to, label, Icon }) => (
              <NavLink
                key={to}
                to={to}
                title={label}
                className={({ isActive }) =>
                  isActive ? "owner-topbar-tab active" : "owner-topbar-tab"
                }
              >
                <Icon size={20} strokeWidth={1.75} />
              </NavLink>
            ))}
          </nav>
          <button
            type="button"
            className="owner-topbar-logout"
            onClick={handleLogout}
            title="Sign out"
          >
            <LogOut size={20} strokeWidth={1.75} />
          </button>
        </header>

        <main className="owner-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
